const AdminSidebar = ({ setActivePage, activePage }) => {
  const menuItems = [
    { id: "moderation", label: "Մոդերացիա" },
    { id: "candidates", label: "Բազա թեկնածուների" },
    { id: "companies", label: "Բազա կազմակերպությունների" },
    { id: "vacancies", label: "Բազա աշխատատեղերի" },
    { id: "Blogs", label: "Բազա նորությունների" },
    { id: "packages", label: "Փաթեթներ գործատուների" },
    { id: "notifications", label: "Ծանուցումներ" },
    { id: "mails", label: "Mail նամակներ" },
    { id: "texts", label: "Տեքստեր" },
    { id: "banners", label: "Բաններներ" },
  ];

  return (
    <aside className="p-3 sm:p-4 w-[250px] sm:w-[280px] md:w-[300px] backdrop-blur-2xl min-h-screen shadow-2xl">
      <ul className="flex flex-col gap-2 sm:gap-3">
        {menuItems.map((item) => (
          <li key={item.id}>
            <button
              onClick={() => setActivePage(item.id)}
              className={`py-2 sm:py-2.5 px-3 sm:px-4 text-start rounded w-full transition-all text-sm sm:text-base ${
                activePage === item.id
                  ? "bg-[#008899] text-white shadow-lg scale-[1.02]"
                  : "bg-[#006674] text-white hover:bg-[#004d58]"
              }`}
            >
              {item.label}
            </button>
          </li>
        ))}
      </ul>
    </aside>
  );
};

export default AdminSidebar;